module.exports = __webpack_public_path__ + "img/30.e23c053e.jpg";